import gql from 'graphql-tag';

export const DEAL_SHEET_CONFIGURATION_FRAGMENT = gql`
  fragment DealSheetConfig on DealSheetConfigurationViewModel {
    id
    name
    description
    charges {
      meta {
        amountOfFees
        amountOfTaxes
      }
      data {
        description
      }
    }

    dealRules {
      location
      saleType
      paymentType
      equipmentType
    }
  }
`;
